import React from 'react';
import { ClockIcon } from './icons';
interface PriceUrgencyProps {
  formattedTime: string;
}
export const PriceUrgency: React.FC<PriceUrgencyProps> = ({
  formattedTime
}) => {
  return <section className="py-20 px-6 sm:px-8 lg:px-12 bg-forest-dark text-cream text-center" data-id="element-228">
      <div className="max-w-3xl mx-auto" data-id="element-229">
        <span className="text-xs font-bold tracking-[0.2em] text-gold uppercase block mb-6" data-id="element-230">
          Mission-Driven Pricing
        </span>

        <p className="text-lg sm:text-xl text-cream/80 leading-relaxed mb-8" data-id="element-231">
          Normally, this entire bundle sells for $150+. But because our mission
          is to save 1 million American dogs by 2026, we’ve knocked the price
          down to <strong className="text-gold" data-id="element-232">$37</strong>. This is less than
          the cost of one bag of poor-quality treats.
        </p>

        <div className="bg-forest border border-gold/20 p-6 sm:p-8 rounded-xl shadow-xl max-w-xl mx-auto mb-10" data-id="element-233">
          <p className="text-sm sm:text-base text-cream/90 mb-6" data-id="element-234">
            This price is only available for the current batch of readers. Once
            the timer expires, the price returns to $97.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-235">
            <div className="flex items-center gap-2 bg-black/30 px-6 py-3 rounded-lg border border-gold/30" data-id="element-236">
              <ClockIcon className="w-6 h-6 text-gold" data-id="element-237" />
              <span className="font-mono font-bold text-3xl text-gold tracking-wider" data-id="element-238">
                {formattedTime}
              </span>
            </div>
          </div>
        </div>

        <button className="w-full sm:w-auto bg-gold hover:bg-gold-dark text-forest-dark font-bold text-lg px-10 py-4 rounded shadow-lg transition-all hover:-translate-y-0.5" data-id="element-239">
          SECURE MY $37 COPY NOW
        </button>
      </div>
    </section>;
};